import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const DirectoryGridContainer: StyleRule = () => ({
    position: 'relative',
    gridRow: 'span 2',
    width: '100%',
    height: '100%',
    margin: 'auto',
    padding: pxArrayToRem([14, 9]),
});

export const PotmDetails: StyleRule = () => ({
    margin: pxArrayToRem([18, 0]),
});

export const PotmTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    marginBottom: pxToRem(2),
    color: theme.siteVariables.colors.primitive.black,
    lineHeight: 1.3,
});

export const ProTitle: StyleRule = () => ({
    color: '#717171',
    lineHeight: 1.3,
});

export const VideoAspect: StyleRule<{
    tileHeight: number;
}> = ({ tileHeight }) => ({
    position: 'relative',
    height: '100%',
    maxHeight: pxToRem(tileHeight),
    width: '100%',
    borderRadius: pxToRem(6),
    overflow: 'hidden',
});

export const Cover: StyleRule<{ playing: boolean }> = ({ playing }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: playing ? 0 : 1,
    transition: 'opacity 200ms linear 200ms',
    [`&::after`]: {
        content: '" "',
        display: `block`,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: `rgba(0, 0, 0, 0.2)`,
    },
    [`& > img`]: {
        width: '100%',
        height: 'auto',
        top: 0,
        left: 0,
    },
});

export const Player: StyleRule<{
    tileWidth: number;
}> = ({ tileWidth }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: '100%',
    [`& video`]: {
        transform: `translateX(calc(-50% + ${pxToRem(tileWidth / 2)}))`,
        objectFit: 'fill',
    },
});
